/**
 * Create Scheduled Task Page
 */

import { ScheduledTaskForm } from '../../components/scheduled-tasks/ScheduledTaskForm';
import { PageWrapper } from '@/components/layout/PageWrapper';

export default function CreateScheduledTaskPage() {
  return (
    <PageWrapper padding="default">
      <ScheduledTaskForm mode="create" />
    </PageWrapper>
  );
}